import { IncidentStatuses, type IncidentStatus } from '@models/incidents';
import type { StatusChipTone } from '@components/ui/StatusChip';

export const INCIDENTS_PATH = '/dashboard/incidents';

export function getIncidentUrl(incidentId: string): string {
  return `${INCIDENTS_PATH}/${incidentId}`;
}

export const INCIDENT_STATUS_LABELS: Record<IncidentStatus, string> = {
  [IncidentStatuses.OPEN]: 'Open',
  [IncidentStatuses.IN_PROGRESS]: 'In progress',
  [IncidentStatuses.RESOLVED]: 'Resolved',
  [IncidentStatuses.CLOSED]: 'Closed',
};

export const INCIDENT_STATUS_OPTIONS: { value: IncidentStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All' },
  ...Object.values(IncidentStatuses).map((status) => ({
    value: status,
    label: INCIDENT_STATUS_LABELS[status],
  })),
];

export function getIncidentStatusTone(status: IncidentStatus): StatusChipTone {
  switch (status) {
    case IncidentStatuses.OPEN:
      return 'danger';
    case IncidentStatuses.IN_PROGRESS:
      return 'warning';
    case IncidentStatuses.RESOLVED:
      return 'success';
    default:
      return 'neutral';
  }
}
